import loading from '../app/loading';

export default {
    data: () => ({
        isLoading: false,
    }),
    methods: {
        loadingStart(message) {
            this.isLoading = true;
            loading.start(message);
        },
        loadingEnd() {
            loading.end();
            this.isLoading = false;
        },
        loadingProgress(message, percentComplete) {
            this.isLoading = true;
            loading.update(message, percentComplete);
        },
    },
};
